// Library Import
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import PlusIcon from '~/images/icon/square-plus.png';
import CrossIcon from '~/images/icon/cross-gray.png';

// Components import
import { AddNewPost } from '@/components';

export const AddNewSection = ({
  handleChange,
  handleRemovePost,
  handleAddNewPost,
  getImageFullPath,
  errors,
  itemIndex,
  item,
  itemTitles
}) => {
  const [titles, setTitles] = useState(itemTitles || null);

  return (
    <div className='multi-section-wrapper mb-3'>
      {itemIndex > 0 && (
        <div className='remove-item'>
          <img onClick={() => handleRemovePost(itemIndex)} src={CrossIcon} alt='Cross Icon' />
        </div>
      )}
      <Form.Group className='mb-3' controlId={`post_section_title_${itemIndex}`}>
        <Form.Label>
          セクションタイトル<span className='is-required'>*</span>
        </Form.Label>

        <Form.Select name='title' isInvalid={errors?.title} value={item?.title ? item?.title : ''} onChange={(event) => handleChange(event, itemIndex)}>
          <option value=''>選択してください...</option>
          {titles?.map((option, idx) => (
            <option key={idx} disabled={option?.selected} value={option?.value}>
              {option?.value}
            </option>
          ))}
        </Form.Select>

        <Form.Control.Feedback type='invalid'>{errors?.title}</Form.Control.Feedback>
      </Form.Group>

      {/* Multi Post */}
      <div className='multi-post-wrapper'>
        {item?.sub_items?.map((item, index) => (
          <AddNewPost
            key={index}
            handleChange={handleChange}
            handleRemovePost={handleRemovePost}
            itemIndex={itemIndex}
            postIndex={index}
            item={item}
            getImageFullPath={getImageFullPath}
            errors={errors?.sub_items && errors?.sub_items[index]}
          />
        ))}
        {/* Add new post */}
        <div className='add-new' onClick={() => handleAddNewPost(itemIndex)}>
          <img src={PlusIcon} alt='Plus Icon' />
        </div>
      </div>
    </div>
  );
};

AddNewSection.prototype = {
  handleChange: Proptypes.func,
  handleAddNewPost: Proptypes.func,
  getImageFullPath: Proptypes.func,
  handleRemovePost: Proptypes.func,
  itemIndex: Proptypes.number,
  item: Proptypes.object,
  errors: Proptypes.object,
  itemTitles: Proptypes.array
};
